import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
import Select from "react-select";
const TicketStatusUpdate = ({
  ticketId,
  ticket,
  assetList,
  statusList,
  resolutionList,
  getAuthHeader,
  onUpdated,
}) => {
  const [form, setForm] = useState({
    asset_id: ticket.asset_id ?? "",
    status_id: ticket.ticket_status ?? "",
    resolution_id: ticket.resolution_id ?? "",
    remarks: ticket.ticket_remarks ?? "",
  });

  /* ---------------- UPDATE FORM FIELD ---------------- */
  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /* ---------------- SUBMIT UPDATE ---------------- */
  const submit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        asset_id: Number(form.asset_id),
        status_id: Number(form.status_id),
        resolution_id: Number(form.resolution_id),
        remarks: form.remarks,
      };

      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/update-status`,
        payload,
        { headers: getAuthHeader() }
      );

 toast.success("Status updated successfully!");
       if (onUpdated) onUpdated();
    } catch (err) {
  console.error("Update failed:", err.response?.data || err);

  const res = err.response?.data;

  // 1️⃣ Laravel Validation Errors
  if (res?.errors) {
    Object.values(res.errors).forEach((msgArr) => {
      toast.error(msgArr[0]); // Show each message
    });
    return;
  }

  // 2️⃣ Laravel message key
  if (res?.message) {
    toast.error(res.message);
    return;
  }

  // 3️⃣ Laravel custom error
  if (res?.error) {
    toast.error(res.error);
    return;
  }

  // 4️⃣ Fallback
  toast.error("Failed to update status");
}


  };

  return (
    <div>
      <h4 className="mb-3">Update Status</h4>
 <ToastContainer position="bottom-right" />
      <form onSubmit={submit}>
        {/* ---------------- ASSET ---------------- */}
        <div className="mb-3">
          <label className="form-label">Asset</label>
<Select
  classNames={{
    control: () => "required-select required-tooltip",
  }}
  options={(assetList || []).map((a) => ({
    label: `[${a.company_asset_code}] ${a.name || ""}`,
    value: a.assets_id,
  }))}
  value={
    (assetList || [])
      .map((a) => ({
        label: `[${a.company_asset_code}] ${ a.name || ""}`,
        value: a.assets_id,
      }))
      .find((opt) => opt.value === form.asset_id) || null
  }
  onChange={(selected) =>
    setForm((prev) => ({
      ...prev,
      asset_id: selected ? selected.value : "",
    }))
  }
  placeholder="Select Asset..."
  className="form-control p-0"
/>


        </div>

        {/* ---------------- STATUS ---------------- */}
        <div className="mb-3">
          <label className="form-label">Status</label>
          <select
            className="form-control"
            value={form.status_id}
            onChange={(e) => handleChange("status_id", e.target.value)}
          >
            <option value="">Select Status</option>
            {statusList.map((s) => (
              <option key={s.status_id} value={s.status_id}>
                {s.status_title}
              </option>
            ))}
          </select>
        </div>

        {/* ---------------- RESOLUTION ---------------- */}
        <div className="mb-3">
          <label className="form-label">Resolution</label>
          <select
            className="form-control"
            value={form.resolution_id}
            onChange={(e) =>
              handleChange("resolution_id", e.target.value)
            }
          >
            <option value="">Select Resolution</option>
            {resolutionList.map((r) => (
              <option key={r.res_id} value={r.res_id}>
                {r.res_title}
              </option>
            ))}
          </select>
        </div>

        {/* ---------------- REMARKS ---------------- */}
        <div className="mb-3 required-tooltip">
          <label className="form-label">Remarks</label>
          <textarea
            className="form-control required-input"
            rows={3}
            value={form.remarks}
            onChange={(e) => handleChange("remarks", e.target.value)}
          />
        </div>

        {/* ---------------- SUBMIT BUTTON ---------------- */}
        <button className="btn btn-primary">Save</button>
      </form>
    </div>
  );
};

export default TicketStatusUpdate;
